// Masifi: the user's home view (ui_settings.default_home_view, set in Profile → DefaultViewSelect). ONE rule shared by
// the login redirect (v3/helpers/AuthHelper.js), the dashboard router (routes/index.js) and the sidebar order
// (components-next/sidebar/masifi/useMasifiSidebar.js), so the upstream files only import and call it.
// Returns the route segment: 'dashboard' (native conversations) for the 'conversations' preference; 'leads' otherwise
// (Masifi default, also when there is no user or no preference yet).
export const masifiHomeView = user =>
  user?.ui_settings?.default_home_view === 'conversations'
    ? 'dashboard'
    : 'leads';
